var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinnerBoyWithBlueBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#68ACE0",
    d: "M 376.882 8.286 C 408.299 11.789 421.418 61.874 426.941 105.656 C 432.811 149.087 430.394 186.214 442.823 230.345 C 455.252 274.476 482.526 325.963 471.823 360.288 C 461.121 394.963 412.441 412.475 368.596 431.739 C 324.404 451.002 285.392 472.018 241.891 479.023 C 198.736 486.378 151.092 479.723 130.032 447.15 C 108.627 414.577 113.461 356.085 84.805 314.405 C 56.496 272.725 -5.648 247.857 2.637 227.893 C 11.268 207.929 90.329 193.218 124.854 162.046 C 159.723 130.874 149.711 83.94 162.485 69.58 C 175.259 55.57 210.819 74.133 253.284 61.524 C 295.75 48.915 345.464 5.133 376.882 8.286 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    transform: "matrix(1.400624, 0, 0, 1.655387, 113.103149, 54.202034)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.85,47.86C138.7,35.63,125.55,27.27,112.09,22,86.25,12,55.3,18.31,34.71,36.6A40.27,40.27,0,0,0,22.78,56.3a60.52,60.52,0,0,0-5.26,28.47c.74,16.39,6.8,30.58,21,39.64,10.32,6.59,24.07,9.84,35.95,12.24l1.34.26a10.49,10.49,0,0,0,2.91,9.38c3.07,3,7.81,4,11.52,1.59,3.1-2,5.1-6.46,4.86-10.11a37.27,37.27,0,0,0,4.36-.94c8.25-2.31,15-7,21.57-12.27a141.87,141.87,0,0,0,12.92-11.71c4.87-4.92,10.73-10.17,14.19-16.21C155.82,83.14,155.52,60.86,146.85,47.86Z",
    style: {
      fill: "rgb(255, 224, 189)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.59,88.31A5.28,5.28,0,0,0,12.8,85.8l-.48-.24a6.62,6.62,0,0,0-3.2-.48l-.22,0a5.54,5.54,0,0,0-4.77,2.77,4,4,0,0,0-.22.47,6.53,6.53,0,0,0,.62,8,8,8,0,0,0,5.2,1.93,8.1,8.1,0,0,0,4-.92C17,95.64,18.65,91.5,16.59,88.31Z",
    style: {
      fill: "rgb(255, 224, 189)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.37,132.15a1.74,1.74,0,0,0-1.23-1.22c-5.33-1-11.34-2.33-15.69-5.74a130.3,130.3,0,0,1-10.59-9c-7.37-7.2-13.24-15.3-15.86-25.39a49.14,49.14,0,0,1,1.68-29A72.6,72.6,0,0,1,38.36,48.6c2.77-4.47,5.27-9.31,9.09-12.94,2.07-2-.55-5.07-3-3.83-5.45,2.83-10.74,5.33-14.87,10a51.48,51.48,0,0,0-9.33,16A60.09,60.09,0,0,0,18.2,94a55.44,55.44,0,0,0,19.92,29.87C47.52,130.82,60,134,71.68,134.38a1.72,1.72,0,0,0,1.51-.87c.09-.16.42-.62.33-.89Z",
    style: {
      fill: "rgb(250, 186, 156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.43,62.3a9.22,9.22,0,0,0-9.38,0,11.62,11.62,0,0,0-5.65,9.82,12.3,12.3,0,0,0,1.41,5.7c1.32,2.62,3.44,3.87,6.07,4.9a7.08,7.08,0,0,0,3.69.3c4.38.23,8.44-3.58,9.31-7.73A12,12,0,0,0,54.43,62.3Z",
    style: {
      fill: "rgb(245, 138, 122)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.76,60.8a8.39,8.39,0,0,0-10.61-8,8.11,8.11,0,0,0-4.25,2.94,4,4,0,0,0-1.05,1.8,6.19,6.19,0,0,0-.71,3.15c-.27,2.13,1,4.64,2.47,6.09a8.41,8.41,0,0,0,5.89,2.5,7.54,7.54,0,0,0,5.66-2.52A8.26,8.26,0,0,0,133.76,60.8Z",
    style: {
      fill: "rgb(245, 138, 122)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.91,161.56a11.45,11.45,0,0,0-1.9-2.47,12.92,12.92,0,0,0-1.13-.92c-1-.77-1.12-.86-.32-.26.61.47.68.52.22.12a13.38,13.38,0,0,0-12.46-2.68,14,14,0,0,0-9.5,9.81,15.2,15.2,0,0,0,.05,7.52,11.16,11.16,0,0,0,7.53,7.95,7.8,7.8,0,0,0,5.14,0l.06,0a12.46,12.46,0,0,0,14-13.1A12.85,12.85,0,0,0,96.91,161.56Z",
    style: {
      fill: "rgb(255, 206, 6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224,33.77c-.06-.24-.12-.48-.19-.72a2.87,2.87,0,0,0-4.18-1.7,2.93,2.93,0,0,0-1.31,1.7l-.21.72a3.05,3.05,0,1,0,5.89,0Z",
    style: {
      fill: "rgb(255, 206, 6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.7,43.77c-3.62-5.74-11.83-8.19-17.93-10.28-4.62-1.59-10.28-1.47-12.64,3.57-2.56,5.49,1.21,12.26,3.32,17.26a85.64,85.64,0,0,0,12.36,20.87c2,2.47,5.32-.67,4.13-3.18-4.23-8.92-9.13-18-12.25-27.37-.81-2.46-1.38-4.67,1.73-5.33,2.31-.49,5.19,1.16,7.13,2.09,3.83,1.83,7.57,4.67,11.77,5.47C185,47.19,186.76,45.43,185.7,43.77Z",
    style: {
      fill: "rgb(255, 206, 6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.46,66.4c1.89-5,2.8-10.18,1.64-15.51-1.64-7.54-7.51-14.53-15.23-16.16-7.52-1.6-13.16.53-17.36,4.71a20.4,20.4,0,0,0-6,4.1c-5.79,5.68-7.84,13.55-9.78,21.15-2.17,8.48-4.87,17-6.45,25.62-.79,4.34-.94,8.78,1.37,12.73.15.26.32.51.48.75-3.42,3.14-4.69,8.74-6.4,12.85-2.4,5.76-5.13,11.72-6.74,17.78a3.91,3.91,0,0,0-.89.71,3,3,0,0,0-3.72-.26l-6.55,3.72c-3.56,2-1.86,7.37,2,7.5h1.37a11.15,11.15,0,0,0,1.92,1.49,4.88,4.88,0,0,0,5.32,3.27l.45,0,.29.33,0-.05a4.43,4.43,0,0,0,6.76-.82c1.81-2.57,1-5.27-.94-7.09.33-1.14.66-2.28,1-3.43a4.51,4.51,0,0,0-2.24-5.22,93.5,93.5,0,0,0,4.59-8.56,3.7,3.7,0,0,0,4.15-1.32q3.38-4.52,6.74-9c1.54-2.06,3.18-3.91,4.1-6.17a11.16,11.16,0,0,0,1.9-.21c7.6-1.5,13.8-9.25,19-14.63A108.19,108.19,0,0,0,222,75.38c1.1-1.85,2.15-3.77,3.09-5.75,2.09,2.86,5.53,4.31,8.64,6,4.91,2.62,13.09,9,6.29,14.63C236,93.57,229,93.69,224,93.44c-4.54-.23-9.79-2.83-13.88-.3a2.68,2.68,0,0,0-1,3.65c3.84,5.61,13.4,3.43,19.19,2.25,5.5-1.11,14.08-3.33,17.63-8.14C254.8,78.94,235.23,69.47,226.46,66.4Z",
    style: {
      fill: "rgb(255, 206, 6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.07,59.06a4,4,0,0,0-4.71-.61c-3.48,1.8-3.29,4.76-4.07,8.18a51.93,51.93,0,0,1-4,11.36A114.77,114.77,0,0,1,194.7,97.72a1.7,1.7,0,0,0,2.05,2.65A42.52,42.52,0,0,0,215.1,82.58C218.24,77,225.37,64.62,220.07,59.06Z",
    style: {
      fill: "rgb(248, 151, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.84,144.45a14.84,14.84,0,0,0-.62-3.33,15.27,15.27,0,0,0-.28-2c-.52-2.44-4-2.2-4.7,0a12.86,12.86,0,0,0-.37,1.72,14.51,14.51,0,0,0-1,3.61c-.39,1.73.52,4.13,2.52,4.44a7.64,7.64,0,0,0,1,.13C167,149.05,168.16,146.7,167.84,144.45Z",
    style: {
      fill: "rgb(248, 151, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.45,108.64c-1.39.69-2,2-2.76,3.32l-1.92,3.51a1.74,1.74,0,0,0,2.72,2.1l3-2.7a6.87,6.87,0,0,0,2.55-3.48A2.46,2.46,0,0,0,179.45,108.64Z",
    style: {
      fill: "rgb(248, 151, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.52,94.84c-2.89-1-7.94-2.18-10.47.09a1.43,1.43,0,0,0,0,2c2.17,2.57,7.54,1.92,10.47,1.35C224.37,97.91,224.05,95.36,222.52,94.84Z",
    style: {
      fill: "rgb(248, 151, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.22,50.1a9.2,9.2,0,0,0-3.71-6.78,1.08,1.08,0,0,0-1.69,1.3,11.87,11.87,0,0,1,1.26,5.81c-.1,1.92-1.48,3.47-1.38,5.34a2,2,0,0,0,3,1.74C227.17,56.31,227.45,52.5,227.22,50.1Z",
    style: {
      fill: "rgb(248, 151, 29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.16,40.79a5.16,5.16,0,0,0-4.56-3.12l-.33,0a3.63,3.63,0,0,0-1.09,0,5.68,5.68,0,0,0-1.74-.3A5.55,5.55,0,0,0,203,39.7a7.26,7.26,0,0,0,1.38,9.41,7.36,7.36,0,0,0,9.58.58C216.9,47.35,216.8,43.73,215.16,40.79Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.9,53.56c-8.94,8.25-11.76,24.92-10.78,36.49.18,2.11,3.16,3.37,4.31,1.17A97.69,97.69,0,0,1,195,77c3.5-4.58,8.11-8.3,11.05-13.29C210.92,55.35,199.78,47.22,192.9,53.56Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.86,39.92l-.1.06C165.85,39.94,165.87,39.92,165.86,39.92Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.1,34.42a13.87,13.87,0,0,0-4.18-1.17,13.31,13.31,0,0,0-2-.26,7.68,7.68,0,0,0-3,1,3.75,3.75,0,0,0,3.79,6.48c-.48.24,1.17-.55,1.23-.54a4,4,0,0,1,.89-.58s1.05.07,1.23.11a2.8,2.8,0,0,0,3.25-1.6A2.74,2.74,0,0,0,170.1,34.42Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.48,81.49c-1.06-2.5-3.43-4.55-6.17-4.3-2.22-.57-4.66,1.85-3.8,4a13.24,13.24,0,0,0,.07,4.61c0,.19,0,.33,0,.2,0,0,0,.09,0,.13a4.76,4.76,0,0,0,2.27,4.74c1.73.91,4.48,1,5.81-.75a15,15,0,0,0,1.35-1.87l-.48.51A5.46,5.46,0,0,0,251,86.4,7.61,7.61,0,0,0,250.48,81.49Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.15,138.82a2,2,0,0,0-2.26-.92,11,11,0,0,0-2.95,1.18,12.33,12.33,0,0,0-2.19,1.95,2.34,2.34,0,0,0-.35,2.76,2.28,2.28,0,0,0,2.57,1.05,13.46,13.46,0,0,0,2.74-1.36,9.65,9.65,0,0,0,2.13-2.24A2.09,2.09,0,0,0,160.15,138.82Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195.72,54.58a5.35,5.35,0,0,0-5.51-.67,5.53,5.53,0,0,0-2.29,1.77,5.14,5.14,0,0,0-1.22,3.26,4.61,4.61,0,0,0,.12,1.81,5.69,5.69,0,0,0,3.83,3.75,5.51,5.51,0,0,0,4.94-1A5.74,5.74,0,0,0,195.72,54.58Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M191.33,67.64l-.07-.13a3.54,3.54,0,0,0-2.71-1.77,3.66,3.66,0,0,0-3.12,1l-.11.11a3.93,3.93,0,0,0-1,3.72,3.85,3.85,0,0,0,3.19,2.74A3.73,3.73,0,0,0,191,71.89,3.92,3.92,0,0,0,191.33,67.64Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211.45,39a2.15,2.15,0,0,0-1.79-.84A3.63,3.63,0,0,0,205,40a3.44,3.44,0,0,0,0,3.36A3.29,3.29,0,0,0,207.85,45a3.78,3.78,0,0,0,3.07-1.4,3.61,3.61,0,0,0,.78-2.23A2.25,2.25,0,0,0,211.45,39Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82,151.08a2.1,2.1,0,0,0-1.85-1.25,4,4,0,0,0-2,.24l-.15.07c-.35-1.85-.74-3.69-1.21-5.52s-3.2-2.27-4-.53a11.51,11.51,0,0,0-1,5.71c0,2.68-1.36,3.4-2.84,5.28s-3.31,5.6-1.28,7.37c-1.31,4.75-1.79,9.57-3.18,14.65-.69,2.54,1.22,4.35,3.54,4.65l.25.18c4.64,4,10-3.81,4.94-6.4a11.31,11.31,0,0,0-2.22-.89c-.61-4.45.7-9.35,2.27-13.78a21.72,21.72,0,0,0,2-3.67c.11-.26.2-.53.3-.8a3,3,0,0,0,2.85-1.62,2.43,2.43,0,0,0,1.27-.13,5.17,5.17,0,0,0,1.24-.63,4.83,4.83,0,0,0,.71-.72A2.07,2.07,0,0,0,82,151.08Z",
    style: {
      fill: "rgb(196, 232, 240)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M99.77,143.74c-.34-3.52-5.73-3.67-5.6,0a6.91,6.91,0,0,1-3.08,6.07c-2.52,1.66-.21,5.71,2.38,4.07.12-.07.23-.16.35-.24A5.83,5.83,0,0,0,95,154.85a2.41,2.41,0,0,0,1.66.33c2.57,7.21,5.43,14.35-.3,20.41-3,3.18-.07,9.16,4.46,7.67a11.19,11.19,0,0,1,3.64-.86c2.82-.43,3.53-3.57,2.62-5.86C111,166.61,100.73,153.54,99.77,143.74Z",
    style: {
      fill: "rgb(196, 232, 240)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.06,167v0c0-.32-.07-.64-.12-1V166c0-.15,0-.3-.07-.44l0,.3a7.74,7.74,0,0,0-3.65-5.52,8.25,8.25,0,0,0-9.9,1.32,8.73,8.73,0,0,0-1.43,10.26,9.12,9.12,0,0,0,3.27,3.4,8.48,8.48,0,0,0,6.39.74,6.86,6.86,0,0,0,4.64-4.41A8.24,8.24,0,0,0,89.06,167Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.93,200.74c-1.29-2.16-1.35-5.16-1.9-7.57a39.05,39.05,0,0,0-2.29-6.82c-1.85-4.26-6.75-3.88-9.64-1.31l-.15-.11c-4.65-3.43-10.12-2.93-15.46-1.7a6.34,6.34,0,0,0-2.88,1.46c-1.62-5.28-10-4.66-12.24.73-2.43,5.9-8,9.48-8.19,16.43-.16,5,2.7,10,7.34,11.94,9.83,4,16.76-6.78,21.68-15.21a7.23,7.23,0,0,0,.21,1.88A19.09,19.09,0,0,0,95,211.11c2.07,1.64,4.94,2.51,7.37.95a15.51,15.51,0,0,0,2.66-2.13c1.19-.3,2.36-.61,3.54-1A5.64,5.64,0,0,0,111.93,200.74Z",
    style: {
      fill: "rgb(248, 156, 72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M68.34,192.06a28.53,28.53,0,0,1-5.24,5.06c-2.27,1.65-5,3.13-6.64,5.43a4.39,4.39,0,0,0,.34,4.9A4.61,4.61,0,0,0,61.44,209c3.12-.46,6.11-3.78,7.85-6.21a27.67,27.67,0,0,0,3.85-8C74,192.24,70.18,189.79,68.34,192.06Z",
    style: {
      fill: "rgb(255, 198, 73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M111.35,207.92a1.16,1.16,0,0,0,0-.18,5.66,5.66,0,0,0-1.62-4.49c-1.25-1.21-2.34-2.55-3.6-3.73a12.17,12.17,0,0,1-3.08-3.74c-1.72-3.69-8-1.07-6.63,2.79.68,1.88.89,3.84,1.47,5.75a22.26,22.26,0,0,0,3,5.78c1,1.5,2.86,3,4.82,2.8l.58.16A4.21,4.21,0,0,0,111.35,207.92Z",
    style: {
      fill: "rgb(255, 198, 73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M124.87,14.13h0c.42-2.51-2.77-4.31-4.31-2.09A16.13,16.13,0,0,0,117.09,14a4.13,4.13,0,0,1-1.66.67,16.66,16.66,0,0,0-2,.65c.51-.19-.73.11-.26.07a5.57,5.57,0,0,0-2.12.63,12.72,12.72,0,0,0,1-7.38c-.22-1.64-2.31-1.68-3.31-.87-4.54,3.67-8.72,5.76-14.55,6.23l-.54,0A25.88,25.88,0,0,0,98.09,2.22C98.3.17,95.71-.3,94.45.71,88,5.87,83.32,17.57,73.13,14.7c-6.57-1.86-9.26,8.94-2.77,10a22.6,22.6,0,0,0,17.12-4.28,6.71,6.71,0,0,0,1.93,2.39c5,3.9,12.9,1.86,17.48-1.77a16.67,16.67,0,0,0,2-1.88c-.21,2,1,4.36,3.14,4.76a11.46,11.46,0,0,0,5.67,0,13.72,13.72,0,0,0,4.4-2.61C124.12,19.64,125.78,16.69,124.87,14.13Z",
    style: {
      fill: "rgb(196, 132, 105)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M141,26.13a2.08,2.08,0,0,0-2.52-.32l-.33.22a6.42,6.42,0,0,0-1.53-.28,3.77,3.77,0,0,0-.48,0,7.51,7.51,0,0,0,1.68-4.5c.12-.26.23-.53.34-.8,1.3-3.13-3.94-5.32-5.47-2.32-.61.24-1.19.49-1.61.64,0,0-1.48.34-1.71.39s-.48.12-.72.17a3.42,3.42,0,0,0-.53,0,5.85,5.85,0,0,0-4.49,2.41,3.44,3.44,0,0,0-1.12,4.56,5.9,5.9,0,0,0,1.21,1.44A5.44,5.44,0,0,0,129.58,30,11.17,11.17,0,0,0,131,29.6a4.14,4.14,0,0,0,0,.86,4,4,0,0,0,3.85,3.39,5.5,5.5,0,0,0,4.54-1.42,6,6,0,0,0,1.4-2.76,6.62,6.62,0,0,0,.55-1A2.18,2.18,0,0,0,141,26.13Z",
    style: {
      fill: "rgb(196, 132, 105)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M61.47,19.1c-7.73-1.36-13.53,1.78-20.06,5.58-2,1.18-4,2.58-6.36,3.1-1.66.36-3.13-.08-4.73.09-.31,0-.63.09-1,.16l-.78-.21-.12,0a24,24,0,0,0-1.66-2,1.84,1.84,0,0,0-3.05.81A5.19,5.19,0,0,0,24,30.47c.08.18.13.32.17.43a3.64,3.64,0,0,0,.17.86l.1.31a5.49,5.49,0,0,0,1.76,4.67,16.11,16.11,0,0,0-3.07.14A2.53,2.53,0,0,0,20.3,41c.16.14.34.27.51.41a6.79,6.79,0,0,0,3.92,2.84A8.49,8.49,0,0,0,31,43.54a3.24,3.24,0,0,0,1.15-4.81,21.16,21.16,0,0,0,6.16-1.61c8-3.22,13.67-13.7,22.63-13.93C63.16,23.14,63.87,19.53,61.47,19.1Z",
    style: {
      fill: "rgb(196, 132, 105)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.21,10l-2.78-2.37a2.83,2.83,0,0,0-3.33-.43,2.79,2.79,0,0,0-1.26,3.11L165,13.61a3.8,3.8,0,0,0,5.5,2.23C172.42,14.7,173.07,11.55,171.21,10Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189,13.67c-1.19-2.3-2.81-5.43-5.33-6.6l-.81-.82a2.59,2.59,0,0,0-4.37,1.81c0,.34,0,.68-.05,1-1.13,2.62-.09,6.25.59,8.79a5.45,5.45,0,1,0,10-4.2Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.07,47.18a3.36,3.36,0,0,0-3.92-2.34,10.47,10.47,0,0,0-4.14-.2,13,13,0,0,0-3.88.89c-1.89.79-2.72,2.3-3.3,4.15a4.39,4.39,0,0,0,2,4.86c2.69,1.81,5.49,1.14,8.06-.53a11.52,11.52,0,0,0,3.6-3.12A3.26,3.26,0,0,0,259.07,47.18Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.63,64l-.9-.8.3.39-.79-1A9.59,9.59,0,0,0,266.76,61a7.24,7.24,0,0,0-4.37-1,7.59,7.59,0,0,0-3.91,2,5.22,5.22,0,0,0-.82,6.33,8.45,8.45,0,0,0,2.54,2.58,7,7,0,0,0,5.22.46,11.07,11.07,0,0,0,2.19-.59,2.49,2.49,0,0,0,1.12-.65l.25-.2,1-.42A3.51,3.51,0,0,0,270.63,64Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.94,69.47l0,0C270,69.46,270,69.46,269.94,69.47Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.73,106c-.73-3.36-3.41-6.52-6.89-7a5.86,5.86,0,0,0-4.9,1,5.55,5.55,0,0,0-2.22,4.42A9.26,9.26,0,0,0,252,107a8.64,8.64,0,0,0,2.06,3.32,10.3,10.3,0,0,0,4.48,2.87c1.89.75,4.37-.15,5.73-1.51A6.06,6.06,0,0,0,265.73,106Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.43,115.22a8.41,8.41,0,0,0-1.7-3,6.42,6.42,0,0,0-2.2-1.35c-3.1-2.16-6.86-.67-7.48,3.08a6,6,0,0,0-.56,2.51,9,9,0,0,0,1.16,3.84,10.64,10.64,0,0,0,3.83,4.37c2.56,1.76,7,.09,7.56-3.07A10.84,10.84,0,0,0,236.43,115.22Z",
    style: {
      fill: "rgb(254, 239, 90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M229.32,66c.27-.74.52-1.48.78-2.23.16-.49-.56-.84-.74-.34-.32.86-.67,1.72-1,2.57-9.26.24-16.48-1.51-23.6-7.82-.39-.35-.83.21-.6.6,4.44,7.64,15.3,12,23.6,8.57a67.85,67.85,0,0,1-5.12,9.07.9.9,0,0,0-.65-.67c-3.15-.78-6.41-1-9.45-2.18a35.35,35.35,0,0,1-8.38-5c-.35-.27-1,.11-.72.54C206.76,75.16,215,79.94,222,77.32a94,94,0,0,1-10.12,12.25c-3.71,3.8-8.54,8.64-13,11.54S187.92,108,182.22,107c-6.8-1.13-7.48-9.54-7.67-15-.59-17.8,7.22-36.46,15.95-51.6,1-1.81-.95-2.87-2.23-1.42-.92,1.06-1.8,2.18-2.64,3.32-7.06-6.19-23.25-18.58-30.69-8.71-4.11,5.46.88,17.67,3.29,22.87,3.59,7.74,6.21,11.34,11.67,16.52,1.24,1.17,3.65-.34,2.65-1.48-4.36-5-8.13-8.8-10.74-14.41a64.68,64.68,0,0,1-5-16.74c-.89-6.27,4.74-7,9.59-6.06,2.66.52,19.53,7.55,18.66,8.78s-1.76,2.63-2.57,4c-4.73-4.94-18.21-14.88-21.61-5.42-1.56,4.32,1.57,10,3.51,13.81,2.24,4.34,5.58,10,9.85,13a91.82,91.82,0,0,0-1.76,10c-1,8.52-3.18,21.53,3.31,28.57,10.14,11,27-4.26,34.67-11.28.82-.76,1.6-1.53,2.37-2.31a43.77,43.77,0,0,0,15.6.65c4.32-.56,10-1.46,12.91-5.21,6.36-8.34-7.64-14.21-12.46-17.83-.43-.32-1,.3-.73.72,3.32,4.78,19.06,10.39,9,17.35-5.78,4-15.26,3.1-22.32,2.15,6.48-7.25,10.81-15.39,14.18-24.63l.06,0a71.35,71.35,0,0,1,13.61,9.58c2.47,2.12,4.59,4,5.39,7.22,1.07,4.34-4.28,9.47-8,11.14-9.75,4.37-19,4-29.24,3.54-1.65-.08-1.9,1.23-.09,1.6,7.38,1.5,14.68,2.43,22.25.67,5.85-1.36,14.28-5,17.52-10.64C257.5,77.56,237.7,69.38,229.32,66Zm-59.44-6.4a46.92,46.92,0,0,1-5.74-10.81c-.49-1.33-1.46-3.48-1.19-5,.93-5.22,6.32-3,9-2a32.11,32.11,0,0,1,9.9,6.37A76.72,76.72,0,0,0,175,65.52C173.31,63.53,171.39,61.7,169.88,59.57Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.28,39.82c4.9,4.35,8.38,9.27,14.27,12.55,5.74,3.2,11.83,4.56,18.18,6a.42.42,0,0,1,0,.83c-12,2.1-29.92-6.2-34.21-18.1A1.15,1.15,0,0,1,196.28,39.82Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M215.41,33.62c-.33-2.17,1.51-4.54,3.24-5.56a5.7,5.7,0,0,1,6.81.52,6.07,6.07,0,0,1,1.62,5.89A4.55,4.55,0,0,1,225.49,37c-.47.35-1.46.68-1.8,0s.51-1.86.64-2.66a3.9,3.9,0,0,0-.79-3.09,2.32,2.32,0,0,0-2.91-.4c-1.5.79-1.45,1.91-1.78,3.34a1.75,1.75,0,0,1-.25.59l1.19.49c9.24,3.9,16.33,12.35,12.13,22.42a.4.4,0,0,1-.75-.24c1.93-8.77-5.53-16-12.86-19a52.18,52.18,0,0,0-10.77-3c-5.27-.88-8.32.11-12.23,3.62-.82.73-2.54-.3-2.06-1.3C197.05,29.92,207.49,31,215.41,33.62Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M246.13,51.51a11.61,11.61,0,0,1,3.87-4c1.49-.9,3.7-1.82,5.4-1.08a1.35,1.35,0,0,1,.21,2.32c-1.12.79-2.67.91-3.91,1.52A9,9,0,0,0,248.49,53C247.56,54.28,245.3,52.89,246.13,51.51Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M260.91,63.72c1.37.13,2.74.25,4.11.4a9.51,9.51,0,0,1,3.79.81,1.29,1.29,0,0,1-.09,2.35,9.34,9.34,0,0,1-3.94,0c-1.47-.14-2.93-.34-4.39-.51C258.38,66.57,258.92,63.53,260.91,63.72Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M180.59,5.56c2.43,1,3.76,3.8,4.48,6.2a13.47,13.47,0,0,1,.56,4.09,35.17,35.17,0,0,1-.66,4c-.08.6-1,.44-.92-.15.21-2.16-.87-4.92-1.7-6.88s-2.5-3.76-3.2-5.88A1.07,1.07,0,0,1,180.59,5.56Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M166.8,9.07a12.78,12.78,0,0,1,2.69,3c.6,1,1.47,2.13,1,3.3a.66.66,0,0,1-.55.39c-1.25,0-2.05-1.18-2.78-2.06a12.74,12.74,0,0,1-2-3.54A1,1,0,0,1,166.8,9.07Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.24,115c1.57-.57,3.47.89,4.38,2.08s2.27,3.85,1,5.33a1.4,1.4,0,0,1-1.95.18c-1-.93-.89-2.55-1.59-3.71A9.41,9.41,0,0,0,229,117.2a4.29,4.29,0,0,1-1.08-1.42A.64.64,0,0,1,228.24,115Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M255.66,102.47a16.66,16.66,0,0,1,4.09,3.16c.64.62,1.26,1.26,1.87,1.92a12.35,12.35,0,0,1,1.5,2.33,1.1,1.1,0,0,1-1.6,1.48,11.48,11.48,0,0,1-1.95-1.52c-.65-.75-1.27-1.52-1.88-2.31a16.91,16.91,0,0,1-2.68-4.46A.48.48,0,0,1,255.66,102.47Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M214.48,82.58c-2.8-.5-5.61-.76-8.08-2.3-.54-.34-2.85-2.66-3.57-1.43-1.2,2,2.66,4.49,4.06,5.2a7.94,7.94,0,0,0,8,0C215.54,83.69,215.14,82.7,214.48,82.58Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M207.51,89.9a12.64,12.64,0,0,1-4.59-1.05c-1.19-.47-2.23-1.44-3.47-1.74a.55.55,0,0,0-.61.46c-.15,1.88,1.87,3.37,3.41,4a6.07,6.07,0,0,0,5.68-.67C208.47,90.58,208,89.89,207.51,89.9Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M155.09,62.79A53.76,53.76,0,0,0,140.92,36,65,65,0,0,0,132,28.24a21.41,21.41,0,0,0,3.89-1.48,15.5,15.5,0,0,0,8.1-8.48c.57-1.41-1.47-2.38-2.43-1.42a39.8,39.8,0,0,1-7.71,6.42,39.82,39.82,0,0,1-5.8,2.31c-.86-.53-1.72-1.05-2.59-1.53.71-.4,1.42-.81,2.11-1.26,2.5-1.62,5.77-3.63,7.2-6.31a1.64,1.64,0,0,0-2.23-2.23C130,15.54,128,18,125.66,19.53c-1.35.89-2.74,1.73-4.18,2.49-2-.92-3.94-1.77-6-2.5a23.41,23.41,0,0,0,8-9.9c.4-1-1.09-1.78-1.78-1-3,3.2-5.78,6.6-9.43,9.09-.26.19-.54.35-.81.52-1.41-.42-2.84-.8-4.27-1.13a23.52,23.52,0,0,0,6.17-6.22c.63-1-.68-2.4-1.68-1.67-3.19,2.31-6.09,4.89-9.46,6.89a81.46,81.46,0,0,0-10.37-1C95.64,10.94,98.44,6,98.05,1a1,1,0,0,0-1.86-.5c-3.35,4.48-5,9.74-8.93,13.92-.18.19-.4.4-.64.63A96.9,96.9,0,0,0,48,24.5c-.84.4-.25,1.8.63,1.5a149.79,149.79,0,0,1,17-4.78c1.19,8.36,13.23,3.69,17.77.91a39.83,39.83,0,0,0,4.84-3.53c2.57,0,5.12.08,7.67.29-3.15,1-6.38,1.66-9.66,2.48a.55.55,0,0,0,0,1.05c5.12.92,11.14-.19,16.41-2.69,1.42.24,2.83.54,4.24.86-1.83.81-3.68,1.56-5.47,2.45-.51.25-.21.93.26,1a19,19,0,0,0,10-2.13c1.92.58,3.81,1.26,5.69,2-1.94.87-1,4.1,1,3.32,1.12-.43,2.23-.88,3.32-1.36,1.17.58,2.32,1.19,3.46,1.84a.46.46,0,0,0,.18.19,5.6,5.6,0,0,0,.7.33c1.14.68,2.28,1.39,3.4,2.15,22.63,15.49,29.62,45.29,15.32,68.81-13.49,22.2-40,36.83-66,36.22-25.71-.61-50-16.1-58.58-40.8-.14-.42-.28-.84-.41-1.27a.29.29,0,0,1,0-.09,1.63,1.63,0,0,0-.51-1.48C13.94,73.26,18.93,55.25,30.71,42a11.14,11.14,0,0,0,4.07-1.78c.48-.35.22-1.22-.43-1a13,13,0,0,1-1.27.3,61,61,0,0,1,5.21-4.65A14.93,14.93,0,0,0,46.47,31c.34-.34,0-1-.5-.85s-1.29.44-1.94.63a64.88,64.88,0,0,1,6.53-3.55c.44-.21.12-.87-.32-.77-1,.24-10.37,3.83-12.58,5.19-.49,0-1-.05-1.47-.11-3.29-.4-5.64-2.17-8.62-3.31a1.56,1.56,0,0,0-1.89,1s0,0,0,0a.06.06,0,0,0,0,.11,1.33,1.33,0,0,0,.13,1.28,11,11,0,0,0,7.38,4.26,47.5,47.5,0,0,0-5,4.64A10.7,10.7,0,0,1,26.45,39c-2.48-.86-4-2.65-6.12-4.07a1.41,1.41,0,0,0-2,1.57c1,3.44,4.14,5.22,7.53,5.68A57.29,57.29,0,0,0,14,85a58.93,58.93,0,0,0,1.78,8.37,10.06,10.06,0,0,1-4.16,2.84A5.93,5.93,0,0,1,5,94.41c-3.53-4.13,1.76-9.73,6.24-7.18a.51.51,0,0,0,.62-.8C6.36,80.2-2.39,88,.61,95a9.88,9.88,0,0,0,9.75,6,11.58,11.58,0,0,0,6.86-3.13c8,21.32,27.7,36.83,50.53,40.83a73.28,73.28,0,0,0,24.5.06c-.52,1.56-.37,3.15-.93,4.74a8.14,8.14,0,0,1-4.6,4.89,6.06,6.06,0,0,1-8.44-6.63.51.51,0,0,0-.93-.39c-2.6,4.16.14,8.86,4.21,10.48a15.49,15.49,0,0,0-2.12.87c-.79.41-.22,1.52.57,1.36,6.42-1.28,13.82.17,17.31,6.29a13.53,13.53,0,0,1-22.27,15.22C69,168,73.46,157.41,82.28,154.84a.42.42,0,0,0-.22-.8c-8.86,2.25-14.56,11-11,20a14.51,14.51,0,0,0,4.62,6.12c-3.72-.29-7.44-.58-11.16-.81,2.89-11.52,5.5-23,7.78-34.68a.54.54,0,0,0-1-.29c-4.08,12-7.76,24-11.17,36.27A2,2,0,0,0,62,183.14c8.88.7,17.78,1.25,26.67,1.85,6.49.45,22.14,4.76,23.14-5.7a18.07,18.07,0,0,0-1.28-7.22l-8.46-26.34a2.16,2.16,0,0,0-.88-1.38,1.51,1.51,0,0,0-2,1.05,4.37,4.37,0,0,0,.22,2.49c1.51,6.05,3.33,12,5.16,18,2,6.51,6.53,16.11-4.2,15.81-2.32-.07-4.63-.18-7-.3a16.55,16.55,0,0,0,6.92-20.88A15.66,15.66,0,0,0,89,151.34,11.78,11.78,0,0,0,93.08,148c1.92-2.47,3.74-6.91,1.86-9.77A82.9,82.9,0,0,0,142.89,109C153.91,95.16,158.2,78.47,155.09,62.79ZM66.7,21a115.45,115.45,0,0,1,15.19-2.15C76.67,22.51,69.51,25.91,66.7,21Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M95.62,16.44a.05.05,0,1,0,0,.1A.05.05,0,0,0,95.62,16.44Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M127.29,61.72c-.71-1.39-2.49-.32-2.31,1,1.6,11.54,1.73,22.31-4.43,32.68a37.83,37.83,0,0,1-29.2,18.08C66.19,115.73,48.5,94.77,48,70.9c0-.48-.77-.62-.87-.12-5.24,26.75,20,49.6,45.85,46.42A41.74,41.74,0,0,0,124,97.37C130,87.15,132.86,72.7,127.29,61.72Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M80.42,46.44c-.17-.64-1-3.93-2.41-3s-1,3.05-.89,4.56c.14,2,.16,4.72,1.31,6.39a1.68,1.68,0,0,0,3-.4C82.14,51.66,81.05,48.72,80.42,46.44Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.06,47A36.11,36.11,0,0,0,95,42.25c-.69-2.08-4.1-1.86-4,.54a40.77,40.77,0,0,0,.63,4.79c.26,1.53.32,3.22,1.51,4.33a1.91,1.91,0,0,0,3-.39C96.82,50,96.37,48.6,96.06,47Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M89.32,174a2.38,2.38,0,0,0-1.32-1,26,26,0,0,0,.15-4.15c.13-3,.21-6,.26-9,0-1.85-2.32-2.22-3.26-.88-1.31,1.85-3.71,4.05-3,6.47a.4.4,0,0,0,.37.28,3.41,3.41,0,0,0,2.1-.75c-.06,1.28-.12,2.56-.17,3.85a24.43,24.43,0,0,0-.16,4.07,10.72,10.72,0,0,0-1.56.3c-1,.28-1.43,2-.32,2.47a12.84,12.84,0,0,0,3.15.94c1.24.2,2.58.51,3.5-.56A1.73,1.73,0,0,0,89.32,174Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.72,206.27a55.66,55.66,0,0,1-5.18-11.05c-1-3-1.51-6.12-3-8.9a.41.41,0,0,0-.74.09c-1.75,6.39,1.4,14.05,4.56,19.93q-7,3.09-14.07,6.21c-3.44-3.73-6.94-8.31-11.17-11.05a22.68,22.68,0,0,0,3.11-7.73c0-.31-.27-.67-.6-.45-3,2-5,5.55-7,8.51-1.53,2.24-2.73,4.81-4.62,6.79-.46.49-10.38,6-5.18,6.39,4.6.33,7.3-2.58,9.61-6.21.83-1.3,1.78-2.69,2.74-4.14,2.91,4.38,7.65,8.08,11.22,11.73a2.09,2.09,0,0,0,2.45.32q8.61-3.89,17.21-7.82A1.93,1.93,0,0,0,117.72,206.27Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M136.7,221.15c-5.46-5.06-13.13-2.28-16.82,3.23-1.92-3.41-3.66-6.95-6.21-9.88-.69-.8-1.93.05-1.7,1,1.26,5,4.26,9.34,6.1,14.09a2.18,2.18,0,0,0,4.17,0c2.42-6.13,7.78-7.25,13.82-6.89A.91.91,0,0,0,136.7,221.15Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M71.69,214.18C68.24,209.86,62,206.85,57,203.87c3.74-6,7.14-12,10.72-18.06.21-.35-.31-.78-.58-.45-4.83,6-9.84,11.92-14.49,18.16a2,2,0,0,0,.7,2.65l.46.32a.35.35,0,0,0-.13,0c-4.54,2.69-11.35,1.2-14.73-2.53a2.17,2.17,0,0,0-3.6,1c-1.49,5.21-4.6,11.69-4,17.14a1.54,1.54,0,0,0,2.85.77c2.69-3.57,3.6-9,4.59-13.74A13,13,0,0,0,45.37,211c3.76,0,6-1.6,8.73-3.86a.31.31,0,0,0,.1-.35c4.91,3.44,10.4,8.37,16,9.91A1.51,1.51,0,0,0,71.69,214.18Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M158.46,126c-4.23,1.85-8,4.76-12.11,7a111.14,111.14,0,0,1-13,6c-7.75,3-17.09,7.06-25.4,4.56-.37-.11-.78.36-.54.7,4.82,6.89,17.63,1.76,23.7-.27,9.8-3.27,22.06-7.86,29.34-15.41C161.79,127.19,160.09,125.34,158.46,126Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M184.72,111.73c-7.14,5.15-13.42,12.47-16.21,20.94-.35.62-.67,1.26-1,1.91a4.66,4.66,0,0,1-3-1.31,2.7,2.7,0,0,1-.32-2.48.82.82,0,0,0,.7.27q-.32-.24,0-.06a1.09,1.09,0,0,0,.57.13,1.85,1.85,0,0,0,.74-.2,8.66,8.66,0,0,0,1.68-1,5.6,5.6,0,0,0,1.9-2.56c.12-.29-.18-.54-.43-.56a5.58,5.58,0,0,0-3.18.54,7.51,7.51,0,0,0-.68.39c.07-.12.12-.24.18-.35a.39.39,0,0,0-.06-.44c.23-.31.45-.63.66-.94l1-.51a11,11,0,0,0,3.41-2.36,1.1,1.1,0,0,0-.77-1.86,5.28,5.28,0,0,0-1.05,0,40.28,40.28,0,0,0,1.51-3.87,2.75,2.75,0,0,0,1.29-1.38.42.42,0,0,0-.12-.45,1.84,1.84,0,0,0-.49-.31c1-3.42,1.72-6.94,2.45-10.4a.42.42,0,0,0-.81-.22,78.92,78.92,0,0,1-4.09,10.54,15.18,15.18,0,0,0-4,1.84c-1.54.94-6,3.83-4.48,6.18s4.09-1.3,5.11-2.25a16.41,16.41,0,0,1,1.36-1.14c-.36.82-.7,1.64-1,2.46a7,7,0,0,0-3.26,1.89,1.53,1.53,0,0,0,1.07,2.57h.55c-.09.27-.19.54-.27.82a.49.49,0,0,0,0,.24,5.94,5.94,0,0,0-2.58,4.79c-1.79.62-3.74.95-5.51,1.71-2.31,1-4.59,2-6.87,3.06-1.56.71-.21,3,1.35,2.31,2.11-1,4.23-2,6.33-3,1.72-.85,3.25-2.08,4.87-3.07a3.48,3.48,0,0,0,.21.59c1,2.37,3.76,3.34,6.19,3.63a22.67,22.67,0,0,0-.22,2.33,7.34,7.34,0,0,0-2.24-.52,17.56,17.56,0,0,1-2.76-.74c-.28-.11-.56.22-.48.49a4.07,4.07,0,0,0,2.34,2.77,3.42,3.42,0,0,0,3.07.18c0,.44,0,.89,0,1.33s0,1,0,1.5c-.64,0-1.29,0-1.94-.07-1,0-2-.6-3-.35a.93.93,0,0,0-.68.89c.25,2.41,3.61,3.21,5.77,2.27a4.19,4.19,0,0,0,.55,1.45c-1.07.15-2.07.49-3.25.6a12.93,12.93,0,0,1-6.57-1.16c-3.48-1.59-6.11-4.79-7.88-8.11a.47.47,0,0,0-.87.24,12.66,12.66,0,0,0,7.22,10.81c3.68,1.88,10.75,3,13.61-.68a1,1,0,0,0-.38-1.64c1-1.68.42-3.79.3-5.75a34.27,34.27,0,0,0-.78-6.14,1.89,1.89,0,0,0,.55-.82c3.08-9,9.63-16.9,15.37-24.51C185.52,112,185,111.49,184.72,111.73Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M161.13,127.49a.05.05,0,1,0,0,.1A.05.05,0,0,0,161.13,127.49Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M64.86,141c-6.76,1.22-13.63,6.65-19.48,10.12-4.5,2.67-12,5.43-14.41,10.51C26,172,42.51,175.21,47.6,180.16a1.07,1.07,0,0,0,1.77-1c-.48-3.53-2.33-5.17-5.47-6.78-5-2.55-14-6.36-5.53-12.21,4.81-3.32,9.93-6.24,14.83-9.43,4.13-2.69,9.11-5.17,12.13-9.13C65.58,141.24,65.17,140.9,64.86,141Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M60,180.06c-.46-1.75-2.62-2.12-4.16-2.5-1.72-.43-3.66-1-5.43-.72a1.05,1.05,0,0,0-.46,1.75c1.27,1.23,3.29,1.83,4.93,2.44s3.4,1.4,4.82.18A1.19,1.19,0,0,0,60,180.06Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M59,187.14c-.61-1.9-2.45-2.64-4.11-3.54a31,31,0,0,0-5.36-2.32c-1.14-.37-1.84,1.11-1.11,1.92a28.7,28.7,0,0,0,4.13,3.73c1.4,1,2.92,2.61,4.78,2.4A1.75,1.75,0,0,0,59,187.14Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M51.31,193.67a34.06,34.06,0,0,0-1.84-5.6,18.36,18.36,0,0,0-3-4.54,1.29,1.29,0,0,0-2.19.9,17.8,17.8,0,0,0,1.57,5.16c.43,1.1,3.72,7.54,5.11,7.14C52.19,196.39,51.49,194.46,51.31,193.67Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerBoyWithBlueBlob);
export default __webpack_public_path__ + "static/media/winnerBoyWithBlueBlob.4f4e25edda9c9ca4c3efdfd341f049ff.svg";
export { ForwardRef as ReactComponent };